import { NestedBubbleMetadata } from '@/components/public/Visualisations/NestedBubbles'
import { Shapes } from '@/components/public/Visualisations/types'
import { makeDarker } from '@/helpers'
import Konva from 'konva'

const STROKE_LIGHTNESS_REDUCTION = 15
const DEFAULT_STROKE_WIDTH = 6

export class NestedBubbleCircleBorder extends Konva.Circle implements Shapes.Shape, Shapes.Selectable {
  readonly entityName = this.constructor.name
  private _metadata: NestedBubbleMetadata
  private _isSelected: boolean = false
  capabilities: Shapes.Capability[] = [Shapes.Capability.Selectable]

  constructor(metadata: NestedBubbleMetadata) {
    super({
      listening: false,
    })

    this._metadata = metadata
    this.strokeWidth(DEFAULT_STROKE_WIDTH / this._metadata.level)
    this.radius(this._metadata.radius + this.strokeWidth() / 2)
    this.position(this._metadata.position)
    this.strokeEnabled(this.isSelected)
    this.refresh()
  }

  get key() {
    return this.path.toString()
  }

  get path() {
    return this._metadata.path
  }

  get center() {
    return this.position()
  }

  get isSelected() {
    return this._isSelected
  }

  set isSelected(value: boolean) {
    this._isSelected = value
    this.strokeEnabled(value)
  }

  refresh() {
    this.stroke(this._stroke)
  }

  private get _stroke() {
    return makeDarker(this._metadata.storyColour, STROKE_LIGHTNESS_REDUCTION)
  }
}
